module.exports = __webpack_public_path__ + "laptop-7262efd3.png";